// extracted by mini-css-extract-plugin
export default {"root":"zGuWlR","itemClickWrapper":"EifCy3","imageZoomBtn":"MuE6Il","sizer":"TOZCrb","imageWrapper":"Stqd2u","imageBorder":"zNt0PP","image":"_4Yu2VW","overlay":"AXQPxJ"};